
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import InputField from "./InputField.vue";
import FormLabel from "./FormLabel.vue";
import FormFeedback from "./FormFeedback.vue";

@Component({
    components: { FormFeedback, FormLabel, InputField },
})
export default class InlineFormSelect extends Vue {
    @Prop() label!: string;
    @Prop() value!: string;
    @Prop({ default: false }) required!: boolean;
    @Prop() help?: string;
    @Prop() error?: string;
    @Prop() customClass?: string;
    @Prop() placeholder?: string;
    @Prop({ default: "text-muted" }) labelClass?: string;
    @Ref("select") readonly select!: HTMLInputElement;
    focused: boolean = false;

    focus() {
        this.focused = true;
        this.$nextTick(() => this.select.focus());
    }

    unfocus() {
        this.focused = false;
    }
}
